import { ModalControls } from "../../../../customHooks/useModalControl";
import {
  formatToCurrency,
  formatToNumber,
  getOffsetFromPage,
  getPageFromOffset,
} from "../../../../helperFunctions";
import {
  SharesApprovalQuery,
  SharesApprovalsResponse,
} from "../../../../redux/features/approvals/approvals.type";
import { SingleSharesLog } from "../../../../redux/features/shares/shares.type";
import { ManualPaymentMethodsMap } from "../../../../utils/constants";
import { ApprovalActionDetails } from "../../../../utils/types";
import { TagCard } from "../../../cards/tagCard";
import { TimeText } from "../../../typography/timeText";
import { TableComponent } from "../../table";

export const SingleSharesApproval = ({
  modalControls,
  setSelectedIds,
  selectedIds,
  approvals,
  setActionDetails,
  setSelectedEntry,
  fetching,
  query,
  setQuery,
}: {
  modalControls: ModalControls;
  selectedIds: number[];
  setSelectedIds: (v: number[]) => void;
  approvals?: SharesApprovalsResponse;
  setActionDetails: (v: ApprovalActionDetails) => void;
  setSelectedEntry: (v: SingleSharesLog) => void;
  fetching: boolean;
  query: SharesApprovalQuery;
  setQuery: (v: SharesApprovalQuery) => void;
}) => {
  const { handleModalOpen } = modalControls;

  return (
    <TableComponent
      mobileCardView
      headers={["Name", "Units", "Amount", "Payment Method", "Payment Date"]}
      headerActionProps={{
        hasActions: true,
        hasCheckbox: true,
        checked:
          selectedIds.length > 0 &&
          selectedIds.length === approvals?.data?.results?.length,
        onCheck: () => {
          setSelectedIds(approvals?.data?.results?.map((i) => i.id) ?? []);
        },
        onUncheck: () => {
          setSelectedIds([]);
        },
        hasMoreMenu: true,
      }}
      rows={
        approvals?.data?.results?.map((entry, idx) => {
          return {
            id: entry.id,
            onClick: () => {
              if (selectedIds.includes(entry.id)) {
                setSelectedIds(selectedIds.filter((i) => i !== entry.id));
              } else {
                setSelectedIds([...selectedIds, entry.id]);
              }
            },
            items: [
              <p className="min-w-fit whitespace-nowrap">
                {entry?.MembershipSharesWalletID?.MemberID?.User?.FirstName}{" "}
                {entry?.MembershipSharesWalletID?.MemberID?.User?.LastName}
              </p>,
              formatToNumber(entry?.Unit, {
                decimalPlaces: 2,
              }),
              formatToCurrency(entry?.Amount, {
                decimalPlaces: 2,
                currency: "NGN",
              }),
              <TagCard
                text={ManualPaymentMethodsMap[entry.paymentMode]}
                type={"info"}
              />,
              <TimeText
                timeString={entry.PaymentDate}
                key={`entry-${entry.id}-date-${idx}`}
              />,
            ],
            actionProps: {
              hasActions: true,
              hasCheckbox: true,
              checked: selectedIds.includes(entry.id),
              onCheck: () => {},
              onUncheck: () => {},
              hasMoreMenu: true,
              moreOptions: [
                {
                  icon: "small-image-icon",
                  text: "View Proof",
                  onClick: () => {
                    setSelectedEntry(entry);
                    handleModalOpen("imageViewModal");
                  },
                  hidden: !entry.payslip,
                },
                {
                  icon: "verified-icon",
                  text: "Accept",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: true,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
                {
                  icon: "close-icon",
                  text: "Decline",
                  onClick: () => {
                    setActionDetails({
                      type: "single",
                      isApprove: false,
                      singleId: entry.id,
                    });
                    setSelectedEntry(entry);

                    handleModalOpen("confirmationModal");
                  },
                },
              ],
            },
          };
        }) ?? []
      }
      stickyLastCol
      isRowClickable={true}
      onRowClick={() => {}}
      isTableEmpty={[0, undefined].includes(approvals?.data?.results?.length)}
      emptyTitle="No Pending Approvals"
      isLoading={fetching}
      isPaginated
      currentPage={getPageFromOffset(query.offset!, query.limit!)}
      totalCount={approvals?.data?.count}
      itemsPerPage={query.limit}
      onPageChange={(page) => {
        setQuery({
          ...query,
          offset: getOffsetFromPage(page, query.limit!),
        });
        setSelectedIds([]);
      }}
    />
  );
};
